import React from 'react';
import { withNamespaces } from 'react-i18next';
import { useMutation, useQueryClient } from 'react-query';

import PayrollFileConfigurationAPI from '../../api/payroll-file-configurations';
import DefaultPayrollFileForm from '../../components/DefaultPayrollFileForm';
import PageBreadcrumbs from '../../components/PageBreadcrumbs';
import Toast from '../../components/Toast';
import PageContainer from '../../containers/PageContainer';
import { INTERNAL_LINKS } from '../../enum';
import withAuthentication from '../../hocs/withAuthentication';

const CreateDefaultPayrollFileView = props => {
  const { t, history } = props;

  const queryClient = useQueryClient();

  const createPayrollFileConfigurationMutation = useMutation(
    data =>
      new PayrollFileConfigurationAPI().createPayrollFileConfiguration({
        ...data,
        isGlobal: true,
      }),
    {
      onSuccess: responseData => {
        queryClient.invalidateQueries(['fetchPayrollFileConfiguration', 'isGlobal']);
        Toast({
          type: 'success',
          message: t('createGlobalPayrollFileConfigurationSuccess'),
        });
        history.replace(INTERNAL_LINKS.UPDATE_DEFAULT_PAYROLL_FILE(responseData._id));
      },
      onError: () => {
        Toast({
          type: 'error',
          message: t('createGlobalPayrollFileConfigurationError'),
        });
      },
    },
  );

  const handleSubmit = payload => {
    createPayrollFileConfigurationMutation.mutate(payload);
  };

  return (
    <PageContainer
      title={
        <PageBreadcrumbs
          items={[
            {
              label: t('globalSettings'),
              onClick: () => history.push(INTERNAL_LINKS.GLOBAL_SETTINGS + '#payrollFile'),
            },
            { label: t('createDefaultPayrollFile') },
          ]}
        />
      }
    >
      <DefaultPayrollFileForm
        t={t}
        onSubmit={handleSubmit}
        loading={createPayrollFileConfigurationMutation.isLoading}
        disabled={createPayrollFileConfigurationMutation.isLoading}
      />
    </PageContainer>
  );
};

export default withNamespaces()(withAuthentication(CreateDefaultPayrollFileView));
